
<ng-container *ngIf="entityHash">
  <app-add-entity [title]="title" [entityHash]="entityHash" [editMode]="true"></app-add-entity>
</ng-container>

